export default __webpack_public_path__ + "static/media/walletFilledIcon.d527d62f.svg";